<template>
<div>
  <div class="driver-list">
    <div v-for="item in list" :key="item.id">

      <div class="driver-item" >
        <div class="driver-item-content">
          <div class="bpm-status" v-if="item.bpmStatus == 1">
            <van-tag type="danger">未提交</van-tag>
          </div>
          <div class="bpm-status" v-else-if="item.bpmStatus == 2">
            <van-tag type="warning">待审核</van-tag>
          </div>
          <div class="bpm-status" v-else-if="item.bpmStatus == 3">
            <van-tag type="primary">审核成功</van-tag>
          </div>
          <div class="driver-name">姓名:{{item.name}}</div>
          <div class="content-item first-item">联系电话:{{item.telphone}}</div>
          <div class="content-item">身份证:{{item.shenfenzheng}}</div>
          <div class="content-item">从业资格证截至日期:{{item.congyezigeyxq}}</div>
        </div>
        <div class="btns-box" v-if="item.bpmStatus == 1">
          <van-button type="info" class="btn-op tjsh" @click="submitBeian(item.id)">提交审核</van-button>
          <van-button type="primary"  class="btn-op" :to="{name: 'escortDetail',params: {id: item.id}}">查看</van-button>
          <van-button type="warning"  class="btn-op"  @click="editBeian(item.id,item.bpmStatus)" >编辑</van-button>
        </div>
        <div class="btns-box" v-if="item.bpmStatus == 2 || item.bpmStatus == 3">
          <van-button type="primary"  class="btn-op2" :to="{name: 'escortDetail',params: {id: item.id}}">查看</van-button>
          <van-button type="warning"  class="btn-op2"  @click="editBeian(item.id,item.bpmStatus)" >编辑</van-button>
        </div>
      </div>

    </div>


  </div>

  <div v-if="isShowBtn == true">
    <div class="add-driver-box">
      <div class="back-step">
        <van-button round block type="default" class="backBtn" :to="{name:'mine'}" >返回</van-button>
      </div>
      <div class="add-step">
        <van-button round block type="info" @click="beianJsz" class="addBtn" color="#316892">新增押运员备案</van-button>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="add-driver-box">
      <div class="back-step2">
        <van-button round block type="default" class="backBtn2" :to="{name:'mine'}" >返回</van-button>
      </div>
    </div>
  </div>
  <Tabbar></Tabbar>

</div>
</template>
<script>
import api from "@/fetch/api"
import {
  Toast,
  Dialog,
} from 'vant';
import Tabbar from '../Public/tabbarTpl.vue'
import store from '@/store';
export default {
  components: {
    Tabbar
  },
  inject: ['reload'],
  data() {
    return {
      isShowBtn: false,
      list: [],
      actionShow: false,
      actions: [{
        name: '查看'
      }, {
        name: '编辑'
      }],
    }
  },
  created() {
    document.title = "押送员备案";
    var that = this;
    var openid = that.$store.state.wx_info.openid;
    that.getEscortByOpenid(openid);
  },
  destroyed() {
    this.destroyDriver()
  },
  methods: {
    // 销毁引导
    destroyDriver() {
      store.state.isFirstTime && this.$driverObj.destroy()
    },
    // 开始引导
    drive() {
      // 判断是否有押运员信息
      if (this.isShowBtn) {// 没有押运员信息, 引导至新增绑定
        this.$nextTick(() => {
          this.$driverObj.highlight({
            element: '.add-step',
            popover: {
              title: '绑定押运员信息',
              // description: '描述文本',
            },
          });
        })
      } else {
        // 有驾驶员信息(驾驶员信息还分待审核和已审核:
        this.$nextTick(() => {
          // 绑定蒸洗+装卸货业务的驾驶员需要审核(bpmStatus != 3)
          // 需要提醒司机点击审核按钮
          if (this.list[0].bpmStatus == 1) {
            this.$driverObj.highlight({
              element: '.tjsh',
              popover: {
                title: '点击"提交审核',
                description: '将您的驾驶员信息提交至后台进行系统审核',
              },
            });
          }// 只高亮驾驶员信息即可
          else if(this.list[0].bpmStatus == 2) {
            this.$driverObj.highlight({
              element: '.driver-item',
              popover: {
                nextBtnText: '完成',
                title: '请等待后台完成审核',
                showButtons: ['next'],
                onNextClick: () => {
                  this.$router.push({
                    path: "/",
                    query: {
                      bootFlag: 'third'
                    }
                  });
                }
              },
            });
          } else if(this.list[0].bpmStatus == 3) {
            // 只绑定蒸洗业务的驾驶员自动审核(bpmStatus == 3)
            // 只高亮驾驶员信息即可
            this.$driverObj.highlight({
              element: '.driver-item',
              popover: {
                nextBtnText: '完成',
                title: '绑定驾驶员信息成功!',
                showButtons: ['next'],
                onNextClick: () => {
                  this.$router.push({
                    path: "/",
                    query: {
                      bootFlag: 'third'
                    }
                  });
                }
              },
            });
          }
        })
      }
    },
    beianJsz() {
      store.state.isFirstTime && this.$driverObj.destroy()
      var that = this;
      that.$router.push({
        name: 'addEscort'
      })
    },
    getEscortByOpenid(openid) {
      var that = this;
      api.getEscortByOpenid(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.$data.list = resData.data;
          that.isShowBtn = (resData.data.length > 0) ? false : true;
          // that.isShowBtn = true;
          store.state.isFirstTime && that.drive()
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'index'
            })
          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');

      });
    },
    editBeian(actionId,bpmStatus) {
      var that = this;
      if (bpmStatus == 3) {
        Dialog.confirm({
            message: '该押运员信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
          })
          .then(() => {
            // on confirm
            that.$router.push({
              name: 'editEscort',
              params: {
                id: actionId
              }
            })
          })
          .catch(() => {
            // on cancel
          });
      } else {
        that.$router.push({
          name: 'editEscort',
          params: {
            id: actionId
          }
        })
      }
    },
    // deleteBeian(id) {
    //
    //   var that = this;
    //   Dialog.confirm({
    //       message: '是否确认删除备案信息',
    //     })
    //     .then(() => {
    //       let formData = new FormData();
    //       formData.append("id", id);
    //
    //       api.deleteBeianYsy(formData).then(function(res) {
    //         var resData = JSON.parse(res);
    //         var resMessage = "";
    //         if (resData.respCode == "0") {
    //           resMessage = '操作成功';
    //         } else {
    //           resMessage = resData.message;
    //         }
    //
    //         Dialog.alert({
    //           message: resMessage,
    //         }).then(() => {
    //           that.reload();
    //         });
    //       }).catch(function() {
    //         Toast.fail('连接失败，请刷新页面');
    //       });
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // },
    // stopBeian(id) {
    //
    //   var that = this;
    //   Dialog.confirm({
    //       message: '是否确认删除备案信息',
    //     })
    //     .then(() => {
    //       let formData = new FormData();
    //       formData.append("id", id);
    //
    //       api.stopBeianYsy(formData).then(function(res) {
    //         var resData = JSON.parse(res);
    //         var resMessage = "";
    //         if (resData.respCode == "0") {
    //           resMessage = '操作成功';
    //         } else {
    //           resMessage = resData.message;
    //         }
    //
    //         Dialog.alert({
    //           message: resMessage,
    //         }).then(() => {
    //           that.reload();
    //         });
    //       }).catch(function() {
    //         Toast.fail('连接失败，请刷新页面');
    //       });
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // },
    submitBeian(id) {
      this.destroyDriver()
      var that = this;
      Dialog.confirm({
          message: '是否确认提交备案信息',
        })
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          api.submitBeianYsy(formData).then(function(res) {
            var resData = JSON.parse(res);
            var resMessage = "";
            if (resData.respCode == "0") {
              resMessage = '操作成功';
            } else {
              resMessage = resData.message;
            }

            Dialog.alert({
              message: resMessage,
            }).then(() => {
              that.reload();
            });

          }).catch(function() {
            Toast.fail('连接失败，请刷新页面');
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // chooseActions(id, bpmStatus) {
    //   var that = this;
    //   that.$data.actionId = id;
    //   that.$data.bpmStatus = bpmStatus;
    //   if (bpmStatus == "1") {
    //     that.$data.actions = [{
    //       name: '查看'
    //     }, {
    //       name: '编辑'
    //     }, {
    //       name: '提交审核'
    //     }];
    //   } else if (bpmStatus == "2") {
    //     that.$data.actions = [{
    //       name: '查看'
    //     }, {
    //       name: '编辑'
    //     }];
    //   } else {
    //     that.$data.actions = [{
    //       name: '查看'
    //     }, {
    //       name: '编辑'
    //     }];
    //   }
    //   this.actionShow = true;
    // },
    // onSelect(item) {
    //   var that = this;
    //   var actionId = that.$data.actionId;
    //   var bpmStatus = that.$data.bpmStatus;
    //   if (actionId) {
    //     switch (item.name) {
    //       case '编辑':
    //         if (bpmStatus == 3) {
    //           Dialog.confirm({
    //               message: '该押运员信息已经审核通过，编辑后需要重新审核，是否进行编辑？',
    //             })
    //             .then(() => {
    //               // on confirm
    //               that.$router.push({
    //                 name: 'editEscort',
    //                 params: {
    //                   id: actionId
    //                 }
    //               })
    //             })
    //             .catch(() => {
    //               // on cancel
    //             });
    //         } else {
    //           that.$router.push({
    //             name: 'editEscort',
    //             params: {
    //               id: actionId
    //             }
    //           })
    //         }
    //         break;
    //         // case '删除':
    //         //   that.deleteBeian(actionId);
    //         //   break;
    //         // case '停用':
    //         //   that.stopBeian(actionId);
    //         //   break;
    //       case '提交审核':
    //         that.submitBeian(actionId);
    //         break;
    //       case '查看':
    //         that.$router.push({
    //           name: 'escortDetail',
    //           params: {
    //             id: actionId
    //           }
    //         });
    //         break;
    //     }
    //   } else {
    //     Toast('网络异常');
    //   }
    // },

  },

}
</script>
<style lang="scss" scoped>
.driver-list {
    margin-bottom: 4.75rem;
    margin-top: 1rem;
    .driver-item {
        margin: 0 1rem 1rem;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
        .driver-item-content {
            align-items: center;
            box-sizing: border-box;
            min-height: 84px;
            padding: 1rem;
            color: #323233;
            .driver-name {
                font-weight: bold;
                font-size: 1rem;
                line-height: 1;
            }
            .content-item {
                line-height: 2;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 0.875rem;
            }

            .first-item {
                margin-top: 0.625rem;
            }
        }
        .driver-item-desc {
            padding: 1rem;
            font-size: 0.875rem;
            border-top: 1px dashed #ebedf0;
        }
        .btns-box{
          .btn-op{
            width: 33.3%;
          }
          .btn-op2
          {
            width: 50%;
          }
        }
    }
}
.bpm-status {
    float: right;
}

.add-driver-box {
    position: fixed;
    bottom: 3.75rem;
    width: 100%;
    padding-bottom: env(safe-area-inset-bottom);
    .back-step {
        display: inline-block;
        width: 50%;
        float: left;
        .backBtn {
            width: 80%;
            margin: 0 auto;
        }
    }

    .back-step2 {
        .backBtn2 {
            width: 90%;
            margin: 0 auto;
        }
    }
    .add-step {
        display: inline-block;
        width: 50%;
        float: right;
        .addBtn {
            width: 80%;
            margin: 0 auto;
        }
    }
}


.edit-box {
    width: 100%;
    .edit-info {
        display: inline-block;
        width: 50%;
        float: left;
        .editBtn {
            width: 80%;
            margin: 0 auto;
        }
    }

    .delete-info {
        display: inline-block;
        width: 50%;
        .deleteBtn {
            width: 80%;
            margin: 0 auto;
        }
    }
}
</style>
